// ----------------------
// <auto-generated>
// Generated using the script normalizrGetterGenerator.js
// </auto-generated>
// -----------------------
import { denormalize, schema } from 'normalizr';
import {
    Category,
    Subcategory,
} from 'services/ApiService/SgmSearch/SgmSearchApiClient';
import { SgmSearchApiSchema, ISgmSearchEntities } from 'services/ApiService';

export class SgmSearchSelectors {
    public static getCategory(id: string | number | null | undefined, entities: ISgmSearchEntities) {
        return SgmSearchSelectors.get<Category>(
             id, 
             entities,
             SgmSearchApiSchema.CategorySchema.key,
             SgmSearchApiSchema.CategorySchema);
    }

    public static getSubcategory(id: string | number | null | undefined, entities: ISgmSearchEntities) {
        return SgmSearchSelectors.get<Subcategory>(
             id, 
             entities,
             SgmSearchApiSchema.SubcategorySchema.key,
             SgmSearchApiSchema.SubcategorySchema);
    }

    public static getCategoryArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: ISgmSearchEntities) {
            return SgmSearchSelectors
            .getArray<Category>(
                ids,
                entities,
                SgmSearchApiSchema.CategorySchema.key,
                SgmSearchApiSchema.CategorySchemaArray);
    }

    public static getSubcategoryArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: ISgmSearchEntities) {
            return SgmSearchSelectors
            .getArray<Subcategory>(
                ids,
                entities,
                SgmSearchApiSchema.SubcategorySchema.key,
                SgmSearchApiSchema.SubcategorySchemaArray);
    }

    private static get<T>(id: string | number | null | undefined, entities: ISgmSearchEntities, schemaKey: string, schema: schema.Entity<T>) {
        if (!SgmSearchSelectors.hasEntitySchema(entities, schemaKey)) {
            return undefined;
        }
        return (denormalize(id, schema, entities) || undefined) as T | undefined;
    }

    private static getArray<T>(ids: ReadonlyArray<string | number> | null | undefined, entities: ISgmSearchEntities, schemaKey: string, schema: schema.Array<T>) {
        if (!ids?.length || !SgmSearchSelectors.hasEntitySchema(entities, schemaKey)) {
            return [];
        }
        return denormalize(ids, schema, entities) as T[];
    }

    private static hasEntitySchema(entities: ISgmSearchEntities, schemaKey: string) {
        return entities.hasOwnProperty(schemaKey);
    }
}
